(function() {
  // Helper to refresh cart drawer
  function refreshCartDrawer() {
    if (!window.routes || !window.routes.cart_url) return;
    
    // Fetch cart drawer section
    fetch(`${window.routes.cart_url}?sections=cart-drawer,cart-counter`)
      .then(res => res.json())
      .then(data => {
        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer && cartDrawer.renderContents) {
          // The GET /cart?sections=... API returns the sections object directly
          // but renderContents expects { sections: ... }
          cartDrawer.renderContents({ sections: data });
        }
      })
      .catch(e => console.error("Error refreshing cart drawer:", e));
  }

  // Intercept fetch
  const originalFetch = window.fetch;
  window.fetch = function() {
    return originalFetch.apply(this, arguments).then((response) => {
      // Check if the request was to add to cart
      // Arguments[0] is the URL
      let url = arguments[0];
      if (url instanceof Request) {
        url = url.url;
      }
      
      if (typeof url === 'string') {
        // Normalize URL to check for cart operations
        // Handles relative URLs, absolute URLs, .js extension or not
        if (url.includes('/cart/add') || 
            url.includes('/cart/update') || 
            url.includes('/cart/change') ||
            url.includes('/cart/clear')) {
          refreshCartDrawer();
        }
      }
      return response;
    });
  };

  // Intercept XMLHttpRequest (for jQuery/older apps)
  const originalOpen = window.XMLHttpRequest.prototype.open;
  const originalSend = window.XMLHttpRequest.prototype.send;

  window.XMLHttpRequest.prototype.open = function(method, url) {
    this._url = url;
    return originalOpen.apply(this, arguments);
  };

  window.XMLHttpRequest.prototype.send = function() {
    this.addEventListener('load', function() {
      if (this._url) {
        const url = this._url.toString();
        if (url.includes('/cart/add') || 
            url.includes('/cart/update') || 
            url.includes('/cart/change') ||
            url.includes('/cart/clear')) {
          refreshCartDrawer();
        }
      }
    });
    return originalSend.apply(this, arguments);
  };
})();
